import { DISPLAY_DATE_FORMAT } from '@msaf/core-common'
import { SearchQuery, SearchTemplate } from '../../../../generic-search-common/src'
import { Filters } from '../../../../generic-search-react/src'
import { MapTabProps } from '../advanced-search-map'
import { TabbedContent } from '@msaf/core-react'
import { RequestOptions } from '@msaf/generic-search-common'

type MapSearchPanelProps = {
  activeSearchTemplate: SearchTemplate
  searchTypeKey: string
  updateQuery: (newQuery: SearchQuery, resetToFirstPage?: boolean | undefined) => Promise<void>
  requestOptions: RequestOptions
  searchQuery: SearchQuery
  dateFormat?: string
  isLoading?: boolean
  isDefaultTabbedContent?: boolean
  onTabChange?: (index: number) => void
  mapTabs?: Array<MapTabProps>
  activeTab?: number
}

export default function MapSearchPanel({
  activeSearchTemplate,
  searchTypeKey,
  updateQuery,
  requestOptions,
  searchQuery,
  dateFormat,
  isLoading,
  isDefaultTabbedContent = true,
  onTabChange,
  mapTabs,
  activeTab,
}: MapSearchPanelProps) {
  const tabs = mapTabs?.map((tab) => {
    return {
      label: tab.label,
      tabContent: (
        <Filters
          searchTemplate={activeSearchTemplate}
          searchTypeKey={tab.searchTypeKey}
          onSearch={updateQuery}
          requestOptions={{
            ...requestOptions,
            urlPrefix: `${requestOptions.urlPrefix}/generic-search`,
          }}
          searchQuery={searchQuery}
          dateFormat={dateFormat ?? DISPLAY_DATE_FORMAT}
          isMapMode={true}
          isLoading={isLoading}
        />
      ),
    }
  })

  return (
    <>
      {isDefaultTabbedContent ? (
        <TabbedContent
          ariaLabel='Search filters'
          tabs={[
            {
              label: 'Custom',
              tabContent: (
                <Filters
                  searchTemplate={activeSearchTemplate}
                  searchTypeKey={searchTypeKey}
                  onSearch={updateQuery}
                  requestOptions={{
                    ...requestOptions,
                    urlPrefix: `${requestOptions.urlPrefix}/generic-search`,
                  }}
                  searchQuery={searchQuery}
                  dateFormat={dateFormat ?? DISPLAY_DATE_FORMAT}
                  isMapMode={true}
                  isLoading={isLoading}
                />
              ),
            },
            {
              label: 'Saved searches',
              tabContent: null,
            },
          ]}
        />
      ) : (
        <TabbedContent ariaLabel='Search filters' activeTab={activeTab} onTabChange={onTabChange} tabs={tabs || []} />
      )}
    </>
  )
}
